module.exports = __webpack_public_path__ + "static/media/16.a8d40fd8.jpg";